import { NgModule } from '@angular/core'

import { FlxBreadcrumbsStyleDirective } from './breadcrumbs-style.directive'
import { FlxBulkFileUploadStyleDirective } from './bulk-file-upload-style.directive'
import { FlxButtonStyleDirective } from './button-style.directive'
import { FlxCheckboxStyleDirective } from './checkbox-style.directive'
import { FlxChoiceStyleDirective } from './choice-style.directive'
import { FlxContainerStyleDirective } from './container-style.directive'
import { FlxDatepickerStyleDirective } from './datepicker-style.directive'
import { FlxDocumentPreviewStyleDirective } from './document-preview-style.directive'
import { FlxErrorStyleDirective } from './error-style.directive'
import { FlxHelperStyleDirective } from './helper-style.directive'
import { FlxHelperTooltipStyleDirective } from './helper-tooltip-style.directive'
import { FlxImageStyleDirective } from './image-style.directive'
import { FlxInputStyleDirective } from './input-style.directive'
import { FlxLabelStyleDirective } from './label-style.directive'
import { FlxLayoutStyleDirective } from './layout-style.directive'
import { FlxMarkdownStyleDirective } from './markdown-style.directive'
import { FlxMessageStyleDirective } from './message-style.directive'
import { FlxModalStyleDirective } from './modal-style.directive'
import { FlxPositionStyleDirective } from './position-style.directive'
import { FlxProgressBarStyleDirective } from './progress-bar-style.directive'
import { FlxRadioStyleDirective } from './radio-style.directive'
import { FlxSegmentedButtonStyleDirective } from './segmented-btn-style.directive'
import { FlxSelectStyleDirective } from './select-style.directive'
import { FlxSeparatorStyleDirective } from './separator-style.directive'
import { FlxSliderStyleDirective } from './slider-style.directive'
import { FlxSwitchStyleDirective } from './switch-style.directive'
import { FlxTabBarStyleDirective } from './tab-bar-style.directive'
import { FlxTableStyleDirective } from './table-style.directive'
import { FlxTextLinkStyleDirective } from './text-link-style.directive'
import { FlxTextareaStyleDirective } from './textarea-style.directive'
import { FlxTooltipStyleDirective } from './tooltip-style.directive'
import { FlxWrapperStyleDirective } from './wrapper-style.directive'

const styleDirectives = [
  FlxBreadcrumbsStyleDirective,
  FlxBulkFileUploadStyleDirective,
  FlxButtonStyleDirective,
  FlxInputStyleDirective,
  FlxTextareaStyleDirective,
  FlxSelectStyleDirective,
  FlxDatepickerStyleDirective,
  FlxSwitchStyleDirective,
  FlxSegmentedButtonStyleDirective,
  FlxSliderStyleDirective,
  FlxMessageStyleDirective,
  FlxSeparatorStyleDirective,
  FlxProgressBarStyleDirective,
  FlxDocumentPreviewStyleDirective,
  FlxTextLinkStyleDirective,
  FlxTabBarStyleDirective,
  FlxWrapperStyleDirective,
  FlxLayoutStyleDirective,
  FlxImageStyleDirective,
  FlxTableStyleDirective,
  FlxContainerStyleDirective,
  FlxCheckboxStyleDirective,
  FlxRadioStyleDirective,
  FlxPositionStyleDirective,
  FlxLabelStyleDirective,
  FlxHelperStyleDirective,
  FlxHelperTooltipStyleDirective,
  FlxErrorStyleDirective,
  FlxChoiceStyleDirective,
  FlxModalStyleDirective,
  FlxMarkdownStyleDirective,
  FlxTooltipStyleDirective,
]

@NgModule({
  imports: styleDirectives,
  exports: styleDirectives,
})
export class FlxStyleModule {}
